import type { ManualSalary } from '@otc/shared';

type ЗаписьЗарплаты = ManualSalary & { employeeId: string; monthKey: string };

/** Одинаковый состав выплаты для месяца, сравнения и годового отчёта. */
export function salariesForMonth(
  записи: readonly ЗаписьЗарплаты[],
  monthKey: string,
): Map<string, ManualSalary> {
  return new Map(
    записи.filter((запись) => запись.monthKey === monthKey).map((запись) => [
      запись.employeeId,
      {
        amountKop: запись.amountKop,
        advanceKop: запись.advanceKop,
        vacationKop: запись.vacationKop,
        bonusKop: запись.bonusKop,
        note: запись.note,
      },
    ]),
  );
}

/** В поле возвращаем ручную сумму, а не итог с уже прибавленными отпускными. */
export function manualSalaryInput(запись: ManualSalary | undefined): string {
  return запись?.amountKop == null ? '' : String(запись.amountKop / 100);
}
